export default "__VITE_ASSET__c9b85cd0__"